var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaxBet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#E3CDFF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2852_4940",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.491 1.66675H6.50768C3.47435 1.66675 1.66602 3.47508 1.66602 6.50841V13.4834C1.66602 16.5251 3.47435 18.3334 6.50768 18.3334H13.4827C16.516 18.3334 18.3243 16.5251 18.3243 13.4917V6.50841C18.3327 3.47508 16.5243 1.66675 13.491 1.66675ZM7.05768 7.48341L9.55768 4.98341C9.61602 4.92508 9.68268 4.88341 9.75768 4.85008C9.90768 4.78341 10.0827 4.78341 10.2327 4.85008C10.3077 4.88341 10.3743 4.92508 10.4327 4.98341L12.9327 7.48341C13.1743 7.72508 13.1743 8.12508 12.9327 8.36675C12.8077 8.49175 12.6493 8.55008 12.491 8.55008C12.3327 8.55008 12.1743 8.49175 12.0493 8.36675L10.616 6.93341V12.0917C10.616 12.4334 10.3327 12.7167 9.99102 12.7167C9.64935 12.7167 9.36602 12.4334 9.36602 12.0917V6.93341L7.93268 8.36675C7.69102 8.60841 7.29102 8.60841 7.04935 8.36675C6.80768 8.12508 6.81602 7.73341 7.05768 7.48341ZM15.1993 14.3501C13.5243 14.9084 11.766 15.1917 9.99935 15.1917C8.23268 15.1917 6.47435 14.9084 4.79935 14.3501C4.47435 14.2417 4.29935 13.8834 4.40768 13.5584C4.51602 13.2334 4.87435 13.0501 5.19935 13.1667C8.29935 14.2001 11.7077 14.2001 14.8077 13.1667C15.1327 13.0584 15.491 13.2334 15.5993 13.5584C15.6993 13.8917 15.5243 14.2417 15.1993 14.3501Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2852_4940)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "inherit"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaxBet);
export default __webpack_public_path__ + "static/media/max-bet.21f35ff732890b696afdcf66efe13aa0.svg";
export { ForwardRef as ReactComponent };